import React, { useContext } from 'react';
import AppContext from '../Context/AppContext';
import SideSheet from './SideSheet';

const SideLeft = ({ children }) => {
    const { sideComponent } = useContext(AppContext)
    const content = sideComponent ? sideComponent : children
    return (
        <>
            <aside className='aside-left df fdc oys'>
                {content}
            </aside>
            <SideSheet>{content}</SideSheet>
        </>
    );
};

export default SideLeft;
